import Plot from 'react-plotly.js'

import { getNLUStats } from '../../../../api/nluData'
import useApiCall from '../../../../api/useApiCall'
import RequestStateHandler from '../../../RequestStateHandler/RequestStateHandler'

import { getPlotlyColorScale, getPlotlyLayout } from '../../../../utils/styles'
import styles from './nlu-stats-content.module.scss'

function NLUStatsContent() {
    const [{ data: analyticsData, ...responseState }] = useApiCall(getNLUStats)

    if (responseState.loading || responseState.error || !analyticsData) {
        return <RequestStateHandler state={responseState} />
    }

    return (
        <>
            {Object.keys(analyticsData).map((key) => (
                <section className={styles.nluStatsContent} key={key}>
                    <Plot
                        data={analyticsData[key].data.map((data) => {
                            data.colorscale = getPlotlyColorScale(data.type)

                            return data
                        })}
                        useResizeHandler
                        layout={{
                            ...analyticsData[key].layout,
                            ...getPlotlyLayout(
                                analyticsData[key].data[0].type || ''
                            ),
                        }}
                        className={styles.nluStatsContent__chart}
                    />
                </section>
            ))}
        </>
    )
}

export default NLUStatsContent
